import React from 'react';

function FlagIconTr({ w, h, style, className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 512 512"
      className={className}
      style={style}
    >
      <circle fill="#D80027" cx="256" cy="256" r="256" />
      <g>
        <polygon
          fill="#F0F0F0"
          points="245.518,209.186 266.523,238.131 300.54,227.101 279.502,256.021 300.504,284.965 266.499,273.893 245.462,302.813 245.484,267.052 211.478,255.98 245.496,244.95"
        />
        <path
          fill="#F0F0F0"
          d="M188.194,328.348c-39.956,0-72.348-32.392-72.348-72.348s32.392-72.348,72.348-72.348c12.458,0,24.18,3.151,34.414,8.696c-16.055-15.702-38.012-25.392-62.24-25.392c-49.178,0-89.043,39.866-89.043,89.043s39.866,89.043,89.043,89.043c24.23,0,46.186-9.691,62.24-25.392C212.374,325.197,200.652,328.348,188.194,328.348z"
        />
      </g>
    </svg>
  );
}

FlagIconTr.defaultProps = {
  w: 20,
  h: 20,
  style: {},
  fill: '#000',
};

export default FlagIconTr;
